import React from "react";

import CompetenceTab from "../../components/Shared/CompetenceTab/CompetenceTab";
import Consultant, { UpdateConsultantRequest } from "../../models/Consultant";
import { useUpdateConsultant } from "../../networking/consultant.hooks";
import ConsultantCredentialsPanel from "./ConsultantCredentialsPanel";

const ConsultantsCompetenceTab: React.FC<{ consultant: Consultant }> = ({ consultant }) => {
	const { mutate: updateConsultant } = useUpdateConsultant();

	const handleUpdateUser = async (user: any, updateRequest: UpdateConsultantRequest) => {
		if (updateRequest.profile?.competences) {
			updateRequest.profile.competences = updateRequest.profile.competences.map((c) => ({
				...c,
				skills: !c.skills?.length ? undefined : c.skills,
			}));
		}

		await updateConsultant({
			userId: user.id,
			update: updateRequest,
		});
	};

	if (!consultant) return null;

	return (
		<div className="max-w-[1400px] py-6 pr-4">
			<div className="grid grid-cols-1 items-start gap-6 xl:grid-cols-5">
				<div className="xl:col-span-3">
					<CompetenceTab user={consultant} onUpdateUser={handleUpdateUser} />
				</div>
				<div className="xl:col-span-2">
					<ConsultantCredentialsPanel consultant={consultant} />
				</div>
			</div>
		</div>
	);
};

export default ConsultantsCompetenceTab;
